<template>
    <div id="footer">
        <ul>
            <li><a :href="reportBaseURL + '/about'" title="About RePORT">About RePORT</a> | </li>
            <li><a :href="reportBaseURL + '/faqs'" title="FAQs">FAQs</a> | </li>            
            <li><a :href="reportBaseURL + '/contactus'" title="Contact Us">Contact Us</a> | </li>
            <li><a :href="reportBaseURL + '/sitemap'" title="Site Map">Site Map</a> | </li>
            <li><a :href="reportBaseURL + '/sites/report/files/2020-07/DataAccessPolicy.pdf'" title="Data Access Policy">Data Access Policy</a> | </li>
            <li><a :href="reportBaseURL + '/accessibility-statement'" title="Accessibility Statement">Accessibility Statement</a> | </li>
            <li><a href="https://grants.nih.gov/grants/privacy.htm" title="Privacy Statement">Privacy Statement</a> | </li>
            <li><a href="https://grants.nih.gov/grants/disclaimer.htm" title="Disclaimer">Disclaimer</a> | </li>
            <li><a href="https://www.nih.gov/icd/od/foia/index.htm" title="FOIA">FOIA</a> | </li>
            <li><a href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html" title="Vulnerability Disclosure Policy">HHS Vulnerability Disclosure</a></li>
        </ul>

        <ul>
            <li><a href="https://grants.nih.gov/grants/oer.htm" title="Office of Extramural Research">Office of Extramural Research</a> | </li>
            <li><a href="https://www.nih.gov/" title="National Institutes of Health">National Institutes of Health</a> | </li>
            <li><a href="https://www.hhs.gov/" title="U.S. Department of Health and Human Services">U.S. Department of Health and Human Services</a> | </li>
            <li><a href="https://www.usa.gov/" title="USA.gov - Government Made Easy">USA.gov - Government Made Easy</a> | </li>
            <li><a href="https://www.grants.gov/" title="Grants.gov">Grants.gov</a></li>
        </ul>

        <div class="footer-tagline">
            <span>NIH...<em>Turning Discovery Into Health<sup>&reg;</sup></em></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data () {
        return {
            baseURL: window.baseURL,
            reportBaseURL: window.location.origin
        };
    }
};
</script>

<style lang="scss">

#footer {
    margin: 0;
    padding: 20px 0 40px;
    background-color: #ececec;
    text-align: center;
    transition: 0.3s;
    height: $footer-height;

    ul {
        margin: 0 30px 20px 40px;
        // padding: 15px 0 0;
        padding: 0;
        list-style: none;

        // &:first-child {
        //     border-top: 2px solid #e0e0e0;
        // }
    }

    li {
        display: inline-block;
    }

    &,
    a {
        // color: #717171;
        color: #454d55;
        font-size: 12px;
        font-weight: 500;
    }

    a {
        padding: 2px 5px;
    }

    .footer-tagline {
        font-weight: normal;
    }
}
</style>
